import { Plugin } from '../plugin';

export class SpriteLoader extends Plugin {
  override name = 'sprite';
}
